var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9043 15.303L13.2305 12H10.7661L7.09221 15.303C6.06461 16.221 5.72814 17.634 6.2283 18.912C6.72846 20.181 7.94702 21 9.32017 21H14.6764C16.0586 21 17.2681 20.181 17.7683 18.912C18.2684 17.634 17.9319 16.221 16.9043 15.303ZM13.6579 17.526H10.3478C10.0022 17.526 9.72939 17.247 9.72939 16.914C9.72939 16.581 10.0113 16.302 10.3478 16.302H13.6579C14.0034 16.302 14.2763 16.581 14.2763 16.914C14.2763 17.247 13.9944 17.526 13.6579 17.526Z",
    fill: "#037DD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7775 5.088C17.2773 3.819 16.0588 3 14.6856 3H9.32032C7.94716 3 6.7286 3.819 6.22845 5.088C5.73738 6.366 6.07385 7.779 7.10145 8.697L10.7753 12H13.2397L16.9136 8.697C17.9321 7.779 18.2686 6.366 17.7775 5.088ZM13.658 7.707H10.3479C10.0023 7.707 9.72953 7.428 9.72953 7.095C9.72953 6.762 10.0114 6.483 10.3479 6.483H13.658C14.0036 6.483 14.2764 6.762 14.2764 7.095C14.2764 7.428 13.9945 7.707 13.658 7.707Z",
    fill: "#037DD6"
  })));
};
export default SvgTimer;